export const PROMETHEE_BLUE = '#22247B';
